import { render } from "./FeatureRequest.vue?vue&type=template&id=1b4b5a08&scoped=true"
import script from "./FeatureRequest.vue?vue&type=script&lang=js"
export * from "./FeatureRequest.vue?vue&type=script&lang=js"

import "./FeatureRequest.vue?vue&type=style&index=0&id=1b4b5a08&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3389461850/src/acx.portal/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b4b5a08"]])

export default __exports__